module.exports = __webpack_public_path__ + "static/media/netlify.72f80ff1.svg";